import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import { deleteDriverLicense } from '../../../../ExperianActions';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import ExperianContext from '../../../../ExperianContext';

const DriverLicense = ({ title, data }) => {
  const [driverLicenseToDelete, setDriverLicenseToDelete] = useState(null);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deleteDriverLicense(clientId, subscriberId, driverLicenseToDelete));
    setDriverLicenseToDelete(null);
  }, [clientId, subscriberId, driverLicenseToDelete, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            <DataItem>
              <DeleteIcon onClick={() => setDriverLicenseToDelete(data)} />
              <DataItemText>{data}</DataItemText>
            </DataItem>
          </ItemContent>
        </div>
        {!!driverLicenseToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => setDriverLicenseToDelete(null)}
          >
            Are you sure you want to stop monitoring:
            <br />
            Driver&apos;s License {driverLicenseToDelete}?
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default DriverLicense;
